import { CgCustomDomainStatus } from '@provision/landing-page-utils';
import { useCgCustomDomains } from 'src/graphql/entities/cg-custom-domain/use-cg-custom-domain';
import { useClientGatewayUrl } from 'src/graphql/entities/client-gateway-url/use-client-gateway-url';

/**
 * Where clients reach a saved landing page: the segment's active custom domain, else the
 * partner's Client Gateway address. Undefined until the page has a slug, i.e. before its first save.
 */
export const useLandingPageLiveUrl = (
  partnerId: number | null,
  brandId: string | undefined,
  slug: string,
): string | undefined => {
  const gatewayUrl = useClientGatewayUrl(partnerId);
  const { domains } = useCgCustomDomains(partnerId);
  const hostname = domains.find(
    (domain) =>
      domain.status === CgCustomDomainStatus.Active &&
      brandId !== undefined &&
      domain.brandIds.includes(brandId),
  )?.hostname;
  const baseUrl = hostname ? `https://${hostname}` : gatewayUrl;

  return baseUrl && slug ? `${baseUrl}/${slug}` : undefined;
};
